var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircleFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    viewBox: "0 0 31.3045 31.3044",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6522,
    cy: 15.6522,
    r: 15.6522,
    fill: "#63CCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0808 14.0625V17.3794H7.82609V14.0625H23.0808ZM17.2418 7.82609V24.0285H13.6804V7.82609H17.2418Z",
    fill: "#F3F4F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleFilledIcon);
export default __webpack_public_path__ + "static/media/AddCircleFilledIcon.8682284e68372defcc47ee33c4e3b1b5.svg";
export { ForwardRef as ReactComponent };